const DEFAULT_WHATSAPP_MESSAGE =
  "Buongiorno, vorrei informazioni sulla RC professionale";

function normalizeWhatsappNumber(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  if (trimmed.length === 0) return null;
  if (!/^\+?[0-9\s().-]+$/.test(trimmed)) return null;

  const digits = trimmed.replace(/\D/g, "").replace(/^00/, "");
  return /^\d{8,15}$/.test(digits) ? digits : null;
}

export function buildWhatsappContactUrl(
  environment: Record<string, unknown>,
  message = DEFAULT_WHATSAPP_MESSAGE,
): string | null {
  const number = normalizeWhatsappNumber(environment.VITE_WHATSAPP_NUMBER);
  if (number === null) return null;
  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
}
